import { EVENT_DEFAULTS, buildDemoStartAt, buildInstallDemoEvent } from "../config/widgetDefaults";

const KEY = "calendar.widgets.v1";

export function generateCalendarId(prefix = "cal") {
  const ts = Date.now().toString(36);
  const rnd = Math.random().toString(36).slice(2);
  const seed = `${prefix}${ts}${rnd}`.replace(/[^a-z0-9]/gi, "").toUpperCase();
  return seed.slice(-8).padStart(8, "0");
}

export function loadWidgets() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveWidgets(list) {
  localStorage.setItem(KEY, JSON.stringify(list));
}

export function appendWidget(widget) {
  const list = loadWidgets();
  saveWidgets([widget, ...list]);
}

export function getWidgetById(widgetId) {
  if (!widgetId) return null;
  const list = loadWidgets();
  return list.find((item) => item?.id === widgetId) || null;
}

export function updateWidgetById(widgetId, patch) {
  if (!widgetId) return false;
  const list = loadWidgets();
  const idx = list.findIndex((item) => item?.id === widgetId);
  if (idx < 0) return false;
  list[idx] = { ...list[idx], ...patch };
  saveWidgets(list);
  return true;
}

export function generateWidgetId(prefix = "w") {
  const ts = Date.now().toString(36);
  const rnd = Math.random().toString(36).slice(2, 8);
  return `${prefix}-${ts}-${rnd}`;
}

/**
 * Upsert a widget by id (used after a successful metafield save so the local cache
 * stays in sync with the source of truth).
 */
export function upsertWidget(widget) {
  if (!widget?.id) return loadWidgets();
  const list = loadWidgets();
  const idx = list.findIndex((item) => item?.id === widget.id);
  if (idx >= 0) {
    list[idx] = { ...list[idx], ...widget };
  } else {
    list.unshift(widget);
  }
  saveWidgets(list);
  return list;
}

/**
 * Replace the cached widget list (e.g. after fetching the metafield on app boot
 * or after a successful save).
 */
export function replaceWidgets(list) {
  saveWidgets(Array.isArray(list) ? list : []);
}

export function newEventDraft(overrides = {}) {
  return {
    id: `e-${Date.now()}-${Math.random().toString(16).slice(2)}`,
    endAt: "",
    calendarId: generateCalendarId(),
    ...EVENT_DEFAULTS,
    startAt: buildDemoStartAt(),
    ...overrides,
  };
}

/** Sample event for new widgets (registration off by default). */
export function newInstallDemoEvent(templateId = "classic-forest") {
  return {
    ...newEventDraft(),
    ...buildInstallDemoEvent(templateId),
    startAt: buildDemoStartAt(),
  };
}
